module.exports = __webpack_public_path__ + "img/symbol_14.c2f7a58c.png";